"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const defaultValue = (0, react_redux_1.useSelector)((state) => state.roomData.refund_policy);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(RefundEditorWrapper, { children: [(0, jsx_runtime_1.jsx)("textarea", { id: "refund_editor", onChange: e => {
                    if (e.target.value.length > 5000) {
                        e.target.value = e.target.value.slice(0, 5000);
                    }
                    const refundPolicyCounter = document.getElementById('refund_policy_counter');
                    refundPolicyCounter.innerText = String(e.target.value.length);
                }, maxLength: 5000, placeholder: `${t('작성하면 문의가 줄어요')} :)`, defaultValue: defaultValue, onBlur: e => dispatch((0, roomCreateStore_1.setRefundPolicy)(e.target.value)) }, `refund_policy_${roomId}_${defaultValue.length}`), (0, jsx_runtime_1.jsxs)("span", Object.assign({ id: "counter" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ id: "refund_policy_counter" }, { children: defaultValue.length })), "/5,000\uC790"] }))] }));
}
exports.default = default_1;
const RefundEditorWrapper = styled_1.default.div `
  position: relative;
  height: 220px;
  min-height: 20vh;
  max-height: 80vh;
  overflow: hidden;
  resize: vertical;
  textarea {
    width: 100%;
    height: 100%;
    padding: 14px;
    border-radius: 8px;
    border: 1px solid var(--gray-10);
    :focus {
      border: 1px solid var(--gray-60);
    }
    font-size: 15px;
    line-height: 22px;
    color: var(--gray-80);
  }
  #counter {
    position: absolute;
    bottom: 10px;
    right: 20px;
    color: rgba(0, 0, 0, 0.2);
    font-size: 14px;
    z-index: 1;
  }
`;
